import React, { ReactNode, useMemo } from 'react';
import { Modal as MantineModal } from '@mantine/core';

export type ModalType = 'extra-large' | 'large' | 'medium' | 'small' | 'auto' | 'full-width' | 'default';

export interface ModalProps {
	show: boolean;
	header?: ReactNode;
	footer?: ReactNode;
	onClose?: () => void;
	size?: ModalType;
	[key: string]: any;
	title?: string;
	showCloseButton?: boolean;
}

function mapSizeToMantineSize(size?: ModalType): 'sm' | 'md' | 'lg' | 'xl' | 'auto' | '100vw' {
	switch (size) {
		case 'small':
			return 'sm';
		case 'large':
			return 'lg';
		case 'extra-large':
			return 'xl';
		case 'auto':
			return 'auto';
		case 'full-width':
			return '100vw';
		default:
			return 'md';
	}
}

export function Modal(props: ModalProps) {
	const { show, header, footer, onClose = () => {}, size = 'auto', showCloseButton = false, title, children } = props;

	const mantineSize = useMemo(() => mapSizeToMantineSize(size), [size]);

	return (
		<MantineModal
			className="form-modal"
			opened={show}
			onClose={onClose}
			centered
			title={title}
			closeOnClickOutside={false}
			closeOnEscape={false}
			withCloseButton={showCloseButton}
			size={mantineSize}
		>
			{header && <div className="modal-header">{header}</div>}
			<div className="modal-body">{children}</div>
			{footer && <div className="modal-footer">{footer}</div>}
		</MantineModal>
	);
}
